<template>
  <div>
    <div v-if="!showEditComponent">
      <div style="display:flex;">
        <div v-if="isLoadComplete && tree.length==0">
          流程模板
          <el-select
            v-model="templateId"
            :remote-method="templateNameList"
            placeholder="空模板"
            class="select_div el-select-custom"
            filterable
            remote
            @change="changeTemplate"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </div>
        <el-button
          type="primary"
          @click="showMainFlowAdd = true">添加主流程</el-button>
        <el-button
          type="primary"
          @click="publish">发布</el-button>
      </div>
      <br >

      <div class="block">
        <el-tree
          :data="tree"
          :props="treeProps"
          :expand-on-click-node="false"
          node-key="id"
          default-expand-all
          empty-text
        >
          <span
            slot-scope="{ node, data }"
            class="custom-tree-node">
            <span class="name">
              <span class="sort">[{{ data.sort }}]</span>
              {{ data.modal_name }}
            </span>
            <span>
              <el-button
                type="text"
                size="mini"
                @click="() => editNode(data)">编辑</el-button>
              <el-button
                type="text"
                size="mini"
                @click="() => removeNode(data.id)">删除</el-button>
              <el-button
                icon="el-icon-plus"
                type="text"
                size="mini"
                @click="() => showFlowEditHandle(data.id,'add')"
              >添加子流程</el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <el-dialog
        :visible.sync="showFlowEdit"
        :title="isAddMainFlow?'添加主流程':'添加子流程'">
        <el-form
          ref="ruleForm"
          :model="formData"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="序号"
            prop="sort">
            <el-input v-model="formData.sort" />
          </el-form-item>
          <el-form-item
            label="标题"
            prop="name">
            <el-input v-model="formData.modal_name" />
          </el-form-item>
        </el-form>

        <span
          slot="footer"
          class="dialog-footer">
          <el-button @click="showFlowEdit = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addFormItem('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="showChildEdit"
        :title="isEditNode?'编辑子节点':'添加子节点'"
        center>
        <el-form>
          <el-form-item label="序号">
            <el-input v-model="form.sort" />
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="form.modal_name" />
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button @click="showChildEdit = false">取 消</el-button>
          <el-button
            type="primary"
            @click="isEditNode?editTemplateCont():addTemplateCont()">保 存</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="showMainFlowAdd"
        title="添加主流程"
        center>
        <el-form>
          <el-form-item label="序号">
            <el-input v-model="form.sort" />
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="form.modal_name" />
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button @click="showMainFlowAdd = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addTemplateCont()">保 存</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="showPreviewFlow"
        title="是否使用该模板?">
        <el-tree
          :data="treeTemplate"
          :props="treeProps"
          :expand-on-click-node="false"
          node-key="id"
          default-expand-all
          empty-text
        >
          <span
            slot-scope="{ node, data }"
            class="custom-tree-node">
            <span class="name">
              <span class="sort">[{{ data.sort }}]</span>
              {{ data.name }}
            </span>
          </span>
        </el-tree>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button @click="showPreviewFlow = false">取消</el-button>
          <el-button
            type="primary"
            @click="confirmUse()">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <FlowContentEdit
      v-if="showEditComponent"
      :form="currEditData"
      :course-id="courseID"
      @backMain="backMain"
    />
  </div>
</template>

<script>
import mapUtils, { $form, $http, axiosRequest } from "@/utils";
import FlowContentEdit from "./FlowContentEdit.vue";

export default {
  name: "FlowList",
  components: {
    FlowContentEdit,
  },

  data() {
    return {
      courseID: this.$route.query.id,
      options: [],
      showFlowEdit: false,
      rules: {
        sort: [
          { required: true, message: "请输入序号", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (!value) {
                callback();
                return;
              }
              const pattern = /^[1-9]\d*$/;

              if (!pattern.test(value)) {
                callback(new Error("请输入正整数"));
              }
              callback();
            },
          },
        ],
        modal_name: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      formData: {
        course_id: this.$route.query.id,
        sort: "",
        modal_name: "",
        parent_id: 0,
      },
      isAddMainFlow: false,
      showFlowAdd: false,
      // 显示主流程按钮
      showAddButton: false,
      // 模板名称
      templateName: "",
      // 模板id
      templateId: "",
      isEditTemplate: false,
      // 编辑流程树表单
      form: {
        template_id: "",
        parent_id: 0,
        modal_name: "",
        sort: "",
        modal_content: "",
        course_id: this.$route.query.id,
      },
      // 编辑标题表单
      editTitleForm: {
        id: "",
        user_id: this.$store.state.user.id,
        title: "",
      },
      tree: [],
      isLoadComplete: false,
      treeTemplate: [],
      treeProps: {
        label: "name",
        children: "leaf",
      },
      // 树的子结构的id
      childContentId: "",
      // 编辑子结构表单
      showChildEdit: false,

      // 编辑组件
      showEditComponent: false,
      // 当前编辑数据
      currEditData: null,
      // 添加主流程
      showMainFlowAdd: false,

      // 预览弹窗
      showPreviewFlow: false,
      currTemplateId: "",
      isEditNode: false,
    };
  },
  computed: {},
  mounted() {
    this.storeBefore();
    console.log(this.$route.query.id);
  },
  methods: {
    storeBefore() {
      console.log($http);
      axiosRequest
        .get(`/lesson_preparation/tree/${this.$route.query.id}`)
        .then((res) => {
          this.tree = res.tree;
          this.isLoadComplete = true;
        });
      this.templateNameList();
    },
    templateNameList(query) {
      // 流程模板列表
      let url = "";
      if (query == "" || query == undefined) {
        url = "/lesson_preparation/store_before";
      } else {
        url = `/lesson_preparation/store_before?like[title]=${query}`;
      }
      axiosRequest.get(url).then((res) => {
        console.log(res);
        this.options = res.template;
      });
    },
    changeTemplate(value) {
      this.showPreviewFlow = true;
      this.currTemplateId = value;
      axiosRequest.get(`/process_template/tree/${value}`).then((res) => {
        this.treeTemplate = res.tree;
      }).catch((error) => {

      });
    },
    confirmUse() {
      const param = {
        template_id: this.currTemplateId,
        course_id: this.$route.query.id,
      };
      axiosRequest.post("/lesson_preparation/use", param).then((res) => {
        this.showPreviewFlow = false;
        axiosRequest
          .get(`/lesson_preparation/tree/${this.$route.query.id}`)
          .then((data) => {
            this.tree = data.tree;
          });
      });
    },

    publish() {
      if (this.tree.length > 0) {
        let ids = [];
        const findIds = (arrayData) => {
          const eleIds = arrayData.map(ele => ele.id);
          ids = ids.concat(eleIds);
          arrayData.forEach((element) => {
            if (element.hasOwnProperty("leaf")) {
              findIds(element.leaf);
            }
          });
        };
        findIds(this.tree);
        console.log("ids--", ids);
        axiosRequest
          .post("/Tutor/editAllLessonPreparationByIds", {
            ids,
            is_submit: 1,
          })
          .then((response) => {
            this.$message.success("发布成功!");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error("请先选择流程模板!");
      }
    },

    addFormItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.showFlowEdit = false;
          axiosRequest
            .post("/lesson_preparation", this.formData)
            .then(() => {});
        } else {
          console.log("error submit!!");
        }
      });
    },

    addTemplate() {
      if (this.templateName) {
        let params = {};
        if (this.isEditTemplate) {
          params = {
            title: this.templateName,
            id: this.templateId,
            user_id: this.$store.state.user.id,
          };
          axiosRequest
            .put(`/process/${params.id}`, params)
            .then((res) => {
              if (this.isEditTemplate) {
                this.$message.success("修改模板标题成功!");
                this.showAddTemplate = false;
                this.initList();
              } else {
                this.$message.success("新建模板成功!");
                this.showAddTemplate = false;
                this.showAddButton = true;
                this.form.template_id = res.data.id;
                this.getContentTree(res.data.id);
                // this.initList();
              }
            })
            .catch((error) => {
              console.log("false");
            });
        } else {
          params.title = this.templateName;
          axiosRequest
            .post("/process", params)
            .then((res) => {
              if (this.isEditTemplate) {
                this.$message.success("修改模板标题成功!");
                this.showAddTemplate = false;
                this.initList();
              } else {
                this.$message.success("新建模板成功!");
                this.showAddTemplate = false;
                this.showAddButton = true;
                this.form.template_id = res.data.id;
                this.getContentTree(res.data.id);
                this.initList();
              }
            })
            .catch((error) => {
              console.log("false");
            });
        }
      }
    },
    // 添加模板内容
    addTemplateCont() {
      if (this.form.sort && this.form.modal_name) {
        delete this.form.modal_content;
        axiosRequest
          .post("/lesson_preparation", this.form)
          .then((res) => {
            this.$message.success("新建模板内容成功!");
            // this.showAddButton = true;
            this.showFlowAdd = false;
            this.showChildEdit = false;
            this.showMainFlowAdd = false;
            this.form.sort = "";
            this.form.modal_name = "";
            this.form.modal_content = "";
            this.form.parent_id = 0;
            axiosRequest
              .get(`/lesson_preparation/tree/${this.$route.query.id}`)
              .then((data) => {
                this.tree = data.tree;
              });
          })
          .catch((error) => {
            this.$message.error("序号重复或者模板已存在!");
          });
      } else {
        this.$message.error("序号和标题不能为空!");
      }
    },
    // 编辑模板内容
    editTemplateCont() {
      if (this.form.sort && this.form.modal_name) {
        this.form.modal_content = this.form.modal_content || "";
        axiosRequest
          .put(`/lesson_preparation/${this.form.id}`, this.form)
          .then((res) => {
            this.$message.success("新建模板内容成功!");
            this.showAddButton = true;
            this.showFlowAdd = false;
            this.showChildEdit = false;
            this.form.sort = "";
            this.form.name = "";
            this.getContentTree(this.templateId);
          })
          .catch((error) => {});
      } else {
        this.$message.error("序号和标题不能为空!");
      }
    },

    // 模板内容树结构
    getContentTree(id) {
      axiosRequest
        .get(`/lesson_preparation/tree/${id}`)
        .then((res) => {
          this.tree = res.tree;
        })
        .catch((error) => {});
    },

    // 显示子节点表单
    showFlowEditHandle(id) {
      this.childContentId = id;
      this.isEditNode = false;
      this.showChildEdit = true;
      this.form.parent_id = id;
    },

    // 编辑节点
    editNode(data) {
      // this.isEditNode = true;
      // axiosRequest
      //   .get(`/lesson_preparation/${id}`)
      //   .then(res => {
      //     this.form = res;
      //     this.showChildEdit = true;
      //   })
      //   .catch(error => {});

      axiosRequest
        .get(`/lesson_preparation/${data.id}`)
        .then((res) => {
          this.currEditData = res;
          this.showEditComponent = true;
        })
        .catch((error) => {});
    },

    backMain() {
      this.showEditComponent = false;
      this.storeBefore();
    },

    // 删除节点
    removeNode(id) {
      this.$confirm("确定删除该流程吗？", "删除确认", {
        showCancelButton: true,
        type: "warning",
        confirmButtonText: "删除",
        confirmButtonClass: "el-button--danger",
        // beforeClose,
      })
        .then(() => {
          axiosRequest
            .delete(`/lesson_preparation/${id}`)
            .then((res) => {
              this.$message.success("删除节点成功!");
              axiosRequest
                .get(`/lesson_preparation/tree/${this.$route.query.id}`)
                .then((resData) => {
                  this.tree = resData.tree;
                });
            })
            .catch((error) => {});
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.select_div {
  margin-right: 20px;
}
.custom-tree-node {
  font-size: 20px;
}
.custom-tree-node .name {
  margin-right: 10px;
}
.custom-tree-node .sort {
  color: blue;
  margin-right: 5px;
}
.el-select-custom .el-input {
  width: 190px;
}
</style>
